/**
 * @flow
 * @relayHash ffa1cbe3579f5ebc21ab8b41eb3db48f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type Direction = "IN" | "OUT" | "%future added value";
export type ContractFromBrokerMutationVariables = {|
  brokerActivityId?: ?string,
  forceCreate?: ?boolean,
|};
export type ContractFromBrokerMutationResponse = {|
  +contractFromBroker: ?{|
    +contract: ?{|
      +id: string,
      +symbol: string,
      +ibConId: any,
    |},
    +brokerActivity: ?{|
      +ibcorporateaction: ?{|
        +id: string,
        +ignored: boolean,
        +processedAt: ?any,
        +processedBy: ?{|
          +username: string,
          +fullName: ?string,
        |},
        +group: ?{|
          +id: string,
          +description: ?string,
        |},
        +transactionId: any,
        +ibConId: number,
        +currency: ?Currency,
        +description: string,
        +isin: ?string,
        +symbol: string,
        +transactionDatetime: any,
        +reportDate: any,
        +quantity: number,
        +proceeds: number,
        +type: string,
        +contract: ?{|
          +id: string,
          +symbol: string,
          +currency: Currency,
          +ibConId: any,
        |},
        +notes: ?{|
          +id: string
        |},
        +brokeractivityPtr: {|
          +id: string,
          +group: ?{|
            +id: string,
            +description: ?string,
          |},
          +responsiblecontract: ?{|
            +contract: {|
              +symbol: string,
              +id: string,
              +ibConId: any,
              +name: ?string,
              +currency: Currency,
              +exchange: {|
                +name: string,
                +symbol: string,
              |},
            |}
          |},
          +brokeractivitytransactionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +account: {|
                  +name: ?string,
                  +id: string,
                |},
                +brokeractivitytransactioncontractdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +portfolio: {|
                        +id: string
                      |},
                      +contract: {|
                        +id: string,
                        +symbol: string,
                      |},
                      +quantity: number,
                    |}
                  |}>
                |},
                +brokeractivitytransactioncashdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +currency: Currency,
                      +quantity: number,
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |},
      |},
      +ibcashtransaction: ?{|
        +id: string,
        +processedAt: ?any,
        +processedBy: ?{|
          +username: string,
          +fullName: ?string,
        |},
        +group: ?{|
          +id: string,
          +description: ?string,
        |},
        +ignored: boolean,
        +ibConId: ?number,
        +currency: ?Currency,
        +description: string,
        +isin: ?string,
        +symbol: ?string,
        +transactionDate: any,
        +reportDate: any,
        +transactionId: ?number,
        +transType: string,
        +fxRateToBase: number,
        +assetCategory: ?string,
        +amount: number,
        +notes: ?{|
          +id: string
        |},
        +contract: ?{|
          +id: string,
          +ibConId: any,
          +currency: Currency,
          +symbol: string,
        |},
        +brokeractivityPtr: {|
          +group: ?{|
            +id: string,
            +description: ?string,
          |},
          +brokeractivitytransactionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +account: {|
                  +id: string,
                  +name: ?string,
                |},
                +brokeractivitytransactioncontractdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +portfolio: {|
                        +id: string
                      |},
                      +contract: {|
                        +id: string,
                        +symbol: string,
                      |},
                      +quantity: number,
                    |}
                  |}>
                |},
                +brokeractivitytransactioncashdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +currency: Currency,
                      +quantity: number,
                    |}
                  |}>
                |},
              |}
            |}>
          |},
          +id: string,
          +responsiblecontract: ?{|
            +id: string,
            +contract: {|
              +id: string,
              +name: ?string,
              +ibConId: any,
              +symbol: string,
              +currency: Currency,
              +exchange: {|
                +name: string,
                +symbol: string,
              |},
            |},
          |},
        |},
      |},
      +ibtransfer: ?{|
        +id: string,
        +processedAt: ?any,
        +processedBy: ?{|
          +username: string,
          +fullName: ?string,
        |},
        +notes: ?{|
          +id: string
        |},
        +ignored: boolean,
        +ibConId: ?number,
        +currency: ?Currency,
        +description: ?string,
        +quantity: number,
        +cashQuantity: number,
        +positionAmount: number,
        +positionAmountInBase: number,
        +isin: ?string,
        +symbol: ?string,
        +reportDate: any,
        +contraAccountId: ?string,
        +contraCompany: ?string,
        +direction: Direction,
        +updatedAt: any,
        +transactionId: any,
        +contract: ?{|
          +id: string,
          +ibConId: any,
          +currency: Currency,
          +symbol: string,
        |},
        +brokeractivityPtr: {|
          +brokeractivitytransactionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +account: {|
                  +name: ?string,
                  +id: string,
                |},
                +brokeractivitytransactioncontractdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +portfolio: {|
                        +id: string
                      |},
                      +contract: {|
                        +id: string,
                        +symbol: string,
                      |},
                      +quantity: number,
                    |}
                  |}>
                |},
                +brokeractivitytransactioncashdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +currency: Currency,
                      +quantity: number,
                    |}
                  |}>
                |},
              |}
            |}>
          |}
        |},
      |},
    |},
  |}
|};
export type ContractFromBrokerMutation = {|
  variables: ContractFromBrokerMutationVariables,
  response: ContractFromBrokerMutationResponse,
|};
*/


/*
mutation ContractFromBrokerMutation(
  $brokerActivityId: ID
  $forceCreate: Boolean
) {
  contractFromBroker(brokerActivityId: $brokerActivityId, forceCreate: $forceCreate) {
    contract {
      id
      symbol
      ibConId
    }
    brokerActivity {
      ibcorporateaction {
        id
        ignored
        processedAt
        processedBy {
          username
          fullName
          id
        }
        group {
          id
          description
        }
        transactionId
        ibConId
        currency
        description
        isin
        symbol
        transactionDatetime
        reportDate
        quantity
        proceeds
        type
        contract {
          id
          symbol
          currency
          ibConId
        }
        notes {
          id
        }
        brokeractivityPtr {
          id
          group {
            id
            description
          }
          responsiblecontract {
            contract {
              symbol
              id
              ibConId
              name
              currency
              exchange {
                name
                symbol
                id
              }
            }
            id
          }
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  name
                  id
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      portfolio {
                        id
                      }
                      contract {
                        id
                        symbol
                      }
                      quantity
                      id
                    }
                  }
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      currency
                      quantity
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      ibcashtransaction {
        id
        processedAt
        processedBy {
          username
          fullName
          id
        }
        group {
          id
          description
        }
        ignored
        ibConId
        currency
        description
        isin
        symbol
        transactionDate
        reportDate
        transactionId
        transType
        fxRateToBase
        assetCategory
        amount
        notes {
          id
        }
        contract {
          id
          ibConId
          currency
          symbol
        }
        brokeractivityPtr {
          group {
            id
            description
          }
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  id
                  name
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      portfolio {
                        id
                      }
                      contract {
                        id
                        symbol
                      }
                      quantity
                      id
                    }
                  }
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      currency
                      quantity
                      id
                    }
                  }
                }
              }
            }
          }
          id
          responsiblecontract {
            id
            contract {
              id
              name
              ibConId
              symbol
              currency
              exchange {
                name
                symbol
                id
              }
            }
          }
        }
      }
      ibtransfer {
        id
        processedAt
        processedBy {
          username
          fullName
          id
        }
        notes {
          id
        }
        ignored
        ibConId
        currency
        description
        quantity
        cashQuantity
        positionAmount
        positionAmountInBase
        isin
        symbol
        reportDate
        contraAccountId
        contraCompany
        direction
        updatedAt
        transactionId
        contract {
          id
          ibConId
          currency
          symbol
        }
        brokeractivityPtr {
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  name
                  id
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      portfolio {
                        id
                      }
                      contract {
                        id
                        symbol
                      }
                      quantity
                      id
                    }
                  }
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      currency
                      quantity
                      id
                    }
                  }
                }
              }
            }
          }
          id
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "forceCreate",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brokerActivityId",
    "variableName": "brokerActivityId"
  },
  {
    "kind": "Variable",
    "name": "forceCreate",
    "variableName": "forceCreate"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ignored",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "processedAt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "processedBy",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionId",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isin",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionDatetime",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "reportDate",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceeds",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v14/*: any*/),
    (v4/*: any*/)
  ]
},
v22 = [
  (v2/*: any*/)
],
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "notes",
  "storageKey": null,
  "args": null,
  "concreteType": "NotesNode",
  "plural": false,
  "selections": (v22/*: any*/)
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "exchange",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeNode",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v3/*: any*/)
  ]
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v2/*: any*/)
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": (v22/*: any*/)
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ]
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncontractdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionContractDeltaNode",
          "plural": false,
          "selections": [
            (v27/*: any*/),
            (v28/*: any*/),
            (v18/*: any*/)
          ]
        }
      ]
    }
  ]
},
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncashdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionCashDeltaNode",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v18/*: any*/)
          ]
        }
      ]
    }
  ]
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v26/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/)
          ]
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionDate",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transType",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fxRateToBase",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "assetCategory",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "contract",
  "storageKey": null,
  "args": null,
  "concreteType": "ContractNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v14/*: any*/),
    (v3/*: any*/)
  ]
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v24/*: any*/)
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cashQuantity",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "positionAmount",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "positionAmountInBase",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contraAccountId",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contraCompany",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "direction",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "processedBy",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v2/*: any*/)
  ]
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "exchange",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeNode",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v3/*: any*/),
    (v2/*: any*/)
  ]
},
v48 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncontractdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionContractDeltaNode",
          "plural": false,
          "selections": [
            (v27/*: any*/),
            (v28/*: any*/),
            (v18/*: any*/),
            (v2/*: any*/)
          ]
        }
      ]
    }
  ]
},
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncashdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionCashDeltaNode",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v18/*: any*/),
            (v2/*: any*/)
          ]
        }
      ]
    }
  ]
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v26/*: any*/),
            (v48/*: any*/),
            (v49/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ContractFromBrokerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contractFromBroker",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractFromBroker",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibcorporateaction",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCorporateActionNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "responsiblecontract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResponsibleContractNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractNode",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v24/*: any*/),
                              (v14/*: any*/),
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v31/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibcashtransaction",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCashTransactionNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v32/*: any*/),
                  (v17/*: any*/),
                  (v13/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v23/*: any*/),
                  (v37/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivitytransactionSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityTransactionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v38/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "responsiblecontract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResponsibleContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v24/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v14/*: any*/),
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibtransfer",
                "storageKey": null,
                "args": null,
                "concreteType": "IBTransferNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v23/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v18/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v13/*: any*/),
                  (v37/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContractFromBrokerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contractFromBroker",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractFromBroker",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityNode",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibcorporateaction",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCorporateActionNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v46/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "responsiblecontract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResponsibleContractNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractNode",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v24/*: any*/),
                              (v14/*: any*/),
                              (v47/*: any*/)
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v50/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibcashtransaction",
                "storageKey": null,
                "args": null,
                "concreteType": "IBCashTransactionNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v46/*: any*/),
                  (v12/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v32/*: any*/),
                  (v17/*: any*/),
                  (v13/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v23/*: any*/),
                  (v37/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivitytransactionSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityTransactionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v38/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "responsiblecontract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResponsibleContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contract",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContractNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v24/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v14/*: any*/),
                              (v47/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ibtransfer",
                "storageKey": null,
                "args": null,
                "concreteType": "IBTransferNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v46/*: any*/),
                  (v23/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  (v18/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v15/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v13/*: any*/),
                  (v37/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      (v50/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ContractFromBrokerMutation",
    "id": null,
    "text": "mutation ContractFromBrokerMutation(\n  $brokerActivityId: ID\n  $forceCreate: Boolean\n) {\n  contractFromBroker(brokerActivityId: $brokerActivityId, forceCreate: $forceCreate) {\n    contract {\n      id\n      symbol\n      ibConId\n    }\n    brokerActivity {\n      ibcorporateaction {\n        id\n        ignored\n        processedAt\n        processedBy {\n          username\n          fullName\n          id\n        }\n        group {\n          id\n          description\n        }\n        transactionId\n        ibConId\n        currency\n        description\n        isin\n        symbol\n        transactionDatetime\n        reportDate\n        quantity\n        proceeds\n        type\n        contract {\n          id\n          symbol\n          currency\n          ibConId\n        }\n        notes {\n          id\n        }\n        brokeractivityPtr {\n          id\n          group {\n            id\n            description\n          }\n          responsiblecontract {\n            contract {\n              symbol\n              id\n              ibConId\n              name\n              currency\n              exchange {\n                name\n                symbol\n                id\n              }\n            }\n            id\n          }\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  name\n                  id\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                        symbol\n                      }\n                      quantity\n                      id\n                    }\n                  }\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      currency\n                      quantity\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ibcashtransaction {\n        id\n        processedAt\n        processedBy {\n          username\n          fullName\n          id\n        }\n        group {\n          id\n          description\n        }\n        ignored\n        ibConId\n        currency\n        description\n        isin\n        symbol\n        transactionDate\n        reportDate\n        transactionId\n        transType\n        fxRateToBase\n        assetCategory\n        amount\n        notes {\n          id\n        }\n        contract {\n          id\n          ibConId\n          currency\n          symbol\n        }\n        brokeractivityPtr {\n          group {\n            id\n            description\n          }\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  id\n                  name\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                        symbol\n                      }\n                      quantity\n                      id\n                    }\n                  }\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      currency\n                      quantity\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          responsiblecontract {\n            id\n            contract {\n              id\n              name\n              ibConId\n              symbol\n              currency\n              exchange {\n                name\n                symbol\n                id\n              }\n            }\n          }\n        }\n      }\n      ibtransfer {\n        id\n        processedAt\n        processedBy {\n          username\n          fullName\n          id\n        }\n        notes {\n          id\n        }\n        ignored\n        ibConId\n        currency\n        description\n        quantity\n        cashQuantity\n        positionAmount\n        positionAmountInBase\n        isin\n        symbol\n        reportDate\n        contraAccountId\n        contraCompany\n        direction\n        updatedAt\n        transactionId\n        contract {\n          id\n          ibConId\n          currency\n          symbol\n        }\n        brokeractivityPtr {\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  name\n                  id\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                        symbol\n                      }\n                      quantity\n                      id\n                    }\n                  }\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      currency\n                      quantity\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '577b45bb4c422fe2cfdc42465756df60';
module.exports = node;
